export const numberCounter = () => {
  const counters = document.querySelectorAll('.count');

  const animateCount = (counter) => {
    const targetText = counter.getAttribute('data-target');

    // Regex: optional prefix, number, optional suffix
    const match = targetText.match(/^([^0-9.-]*)([0-9.,]+)([^0-9]*)$/);
    if (!match) {
      return;
    }

    const prefix = match[1] || '';
    const numberPart = match[2] || '0';
    const suffix = match[3] || '';

    const end = parseFloat(numberPart.replace(/,/g, ''));
    let current = 0;
    const duration = 2000; // 2 seconds
    const step = end / (duration / 30);

    const timer = setInterval(() => {
      current += step;
      if (current >= end) {
        clearInterval(timer);
        counter.textContent = prefix + numberPart + suffix; // exact final value
      } else {
        // if numberPart has decimals, keep them, otherwise use whole numbers
        const formatted = numberPart.includes('.')
          ? current.toFixed(2)
          : Math.floor(current).toLocaleString();
        counter.textContent = prefix + formatted + suffix;
      }
    }, 30);
  };

  // Animate when in view
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.6 },
  );

  counters.forEach((counter) => observer.observe(counter));
};
